import React, {Component} from 'react';
import {Icon, Statistic} from 'antd';
import QRCode from 'qrcode.react';
import PropTypes from 'prop-types';
import '../css/payTemplate.css';
import zfbPng from '../assets/zfb.png';
import {config} from '../app';

class PayTemplate extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let {money, qrcode, no, terminal, generate} = this.props;
    return (
      <div className="pay-template">
        <div>扫一扫付款（元）</div>
        <div className="money"><Statistic value={money} precision={2}/></div>
          {no?<div className="no">订单号 : {no}</div>:null}
        <div className="qrcode">
          <div className="qc-img">
              {
                  generate ? (
                    <QRCode className="qc-qc-img" size={168} value={qrcode}/>
                  ) : (
                    <img className="qc-qc-img" src={qrcode} alt=""/>
                  )
              }
            <img className="zfb-img" src={zfbPng} alt=""/>
          </div>
          <div>
            <Icon type="scan" style={{color: '#FFAE20', fontSize: 36, margin: '5px 0'}}/>
            <span>
                            <div>打开手机{terminal || '支付宝'}</div>
                            <div>扫一扫继续支付</div>
                        </span>
          </div>
        </div>
      </div>
    );
  }
}

PayTemplate.propTypes = {
  money: PropTypes.any,
  qrcode: PropTypes.string,
  terminal: PropTypes.string,
  generate: PropTypes.boolean,
  no: PropTypes.string,
};

export default PayTemplate;



// WEBPACK FOOTER //
// ./src/components/PayTemplate.jsx